import {api} from '../resources'

export default {
    namespaced: true,
    state: {
        incomes: [],
    },
    getters: {
        sortedIncomes: (state) => [...state.incomes].sort((a, b) => a.order - b.order),
        defaultIncome: (state) => state.incomes.find(income => income.is_default) || null
    },
    actions: {
        getIncomes({commit, rootState}) {
            const space_id = rootState.space.current_space.data.id;

            api.incomes.get({space_id}).then(res => {
                if (res.body.success) {
                    commit('setIncomes', res.body.data.rows)
                }
            })
        },
        createIncomeSource({}, data) {
            return api.incomes.save(data);
        },
        saveIncomeSource({commit}, data) {
            return api.incomes.update({id: data.id}, {...data})
        },
        saveDefaultIncomeSource({commit}, id) {
            return api.incomes.update({id}, {is_default: true})
        },
        deleteIncomeSource({}, id) {
            return api.incomes.remove({id})
        },
        updateIncomeSourcesOrders({commit, rootState}, incomesList) {
            const space_id = rootState.space.current_space.data.id;
            let order = {};
            incomesList.forEach((item, o) => {
                order[item.id] = o;
            });
            commit('setIncomes', incomesList)
            api.incomesUpdateOrder.save({space_id, order});
        },
    },
    mutations: {
        setIncomes(state, data) {
            state.incomes = data.sort((a, b) => a.order - b.order)
        },
        setDefaultIncomeSource(state, data) {
            let {id} = data;
            state.incomes = state.incomes.map(item => {
                return {...item, is_default: item.id === id}
            })
        },
        clearIncomes(state) {
            state.incomes = [];
        },
    }
}
